import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from "axios";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { setupOfflineApi } from './offline/apiOffline';
import './assets/css/app-theme.css';
import './assets/css/ui.css';
import './assets/css/forms.css';
import './assets/css/pages.css';
import './assets/css/ai-panel.css';
import './assets/css/print.css';
import { applyBrandingTheme } from './theme/branding';

var user = localStorage.getItem("user") ?  JSON.parse(localStorage.getItem("user")) : {};
axios.defaults.baseURL = process.env.REACT_APP_APIEVIVESOMA;
axios.defaults.headers.common['x-access-token'] = user?.refresh_token ? user.refresh_token : "";
setupOfflineApi();
applyBrandingTheme();
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

serviceWorkerRegistration.register({
  onUpdate: serviceWorkerRegistration.updateServiceWorker,
});
